import {useCallback, useState} from 'react';
import * as Yup from 'yup';

import {useContactMutation} from '../api';

const validationSchema = Yup.object({
  firstname: Yup.string().max(255, 'Firstname is too long'),
  surname: Yup.string().max(255, 'Surname is too long'),
  email: Yup.string().email('Must be an email address').max(255, 'Email is too long').required('Email is required'),
  phone: Yup.string().matches(/^[+()\d ]+$/, {
    message: 'Please enter valid number',
    excludeEmptyString: false,
  }),
  message: Yup.string().required('Please type a message'),
});

const initialValues = {
  firstname: '',
  lastname: '',
  email: '',
  phone: '',
  message: '',
};

const useContactForm = () => {
  const [isSuccess, setIsSuccess] = useState();
  const doContactSubmit = useContactMutation();

  const onSubmit = useCallback(
    async (values, actions) => {
      try {
        await doContactSubmit(values);
        setIsSuccess(true);

        actions.resetForm();
      } catch (e) {
        console.error(e);

        if (e.status === 422) {
          actions.setErrors(e.data?.errors ?? {});
        }
        actions.setSubmitting(false);
      }
    },
    [setIsSuccess]
  );

  return {
    initialValues,
    onSubmit,
    validationSchema,
    isSuccess,
  };
};

export default useContactForm;
